import {FC, useCallback} from 'react';
import {styled} from 'styled-components';

import {asError} from '@shared/lib/utils/type_utils';
import {getPrivacyPolicyUrl, getTermsUrl, LATEST_TERMS_VERSION} from '@shared/models/term';

import {Button, Link} from '@shared_web/components/core/button';
import {showAlert} from '@shared_web/components/core/notifications';
import {SvgIcon} from '@shared_web/components/core/svg_icon';

import {Loader} from '@mavismart_frontend/components/loader';
import {Translate} from '@mavismart_frontend/components/translate';
import {icon_mavismart_logo_red_and_grey} from '@mavismart_frontend/icons/icon_mavismart_logo_red_and_grey';
import {apiCall} from '@mavismart_frontend/lib/api';
import {BUTTON_THEME} from '@mavismart_frontend/lib/constants';
import {setAccount, useAccount} from '@mavismart_frontend/stores/account_store';

export const Terms: FC = () => {
  const account = useAccount();

  const validationTerms = useCallback(async () => {
    if (!account) {
      console.error('Account is not available');
      return;
    }
    try {
      const {termsVersion} = await apiCall('POST /accept-terms', {
        termsVersion: LATEST_TERMS_VERSION,
      });
      setAccount({
        ...account,
        termsVersion,
      });
    } catch (error) {
      showAlert(asError(error).message);
    }
  }, [account]);

  if (!account) {
    return <Loader />;
  }

  return (
    <Wrapper>
      <SvgIcon icon={icon_mavismart_logo_red_and_grey} size={300} />
      <Title>
        <Translate value={'terms'} />
      </Title>
      <TermsWrapper>
        <p>
          <Translate
            value={'accept_terms'}
            params={{
              privacyPolicyLink: (
                <Link href={getPrivacyPolicyUrl()} target="_blank">
                  <Translate value={'privacy_policy'} />
                </Link>
              ),
              br: <br />,
              termsOfServiceLink: (
                <Link href={getTermsUrl(LATEST_TERMS_VERSION)} target="_blank">
                  <Translate value={'terms'} />
                </Link>
              ),
            }}
          />
        </p>
        <WrapperButtons>
          <Button themeOverrides={BUTTON_THEME} onClick={validationTerms}>
            <WrapperSave>
              <Translate value={'agree_and_continue'} />
            </WrapperSave>
          </Button>
        </WrapperButtons>
      </TermsWrapper>
    </Wrapper>
  );
};

Terms.displayName = 'Terms';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
    align-items: center;
`;

const TermsWrapper = styled.div`
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: center;

  p {
    margin-bottom: 20px;
    font-size: 1rem;
    color: #555;
  }
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const WrapperButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  
  button {
    width: 215px;
  }
`;

const WrapperSave = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  span {
    font-size: 1.2rem;
    color: white;
  }
`;
